import { render, staticRenderFns } from "./employeeWorkloadadd.vue?vue&type=template&id=76952b32"
import script from "./employeeWorkloadadd.vue?vue&type=script&lang=js"
export * from "./employeeWorkloadadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports